import React, { useEffect, useState } from 'react'
import { changeStateAuthRequest, getAuthRequestByID } from '../../actions/certificationActions';
import { useDispatch, useSelector } from 'react-redux';
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG';
import { PersonIcon } from '../../../assets/icons/index'

const CertificateUserAuthRequest = ({ match, history }) => {
    let idAuthRequest = match.params.idAuthRequest

    const dispatch = useDispatch();

    const [argument, setargument] = useState('')

    useEffect(() => {
        dispatch(getAuthRequestByID(idAuthRequest))
    }, [])

    const { authRequest } = useSelector((state) => state.certificationAdmin);
    return (
        <div>
            <TitleSVG Icon={PersonIcon}
                titleHighlight={'Datos'}
                title={' de la solicitud'}
            />
            <div className='wrapper-1 column-gap row-gap mt-5'>
                {

                    <div className="card-admin">
                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Nombre: </span>
                            {authRequest?.userID?.name}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Apellido: </span>
                            {authRequest?.userID?.lastname}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Identificación: </span>
                            {authRequest?.userID?.identificationType} {' '}
                            {authRequest?.userID?.identificationNumber} {' '}
                            {<a target="_blank" href={authRequest?.identificationFile?.url.origin}>Ver soporte</a> }
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Ubicación: </span>
                            {authRequest?.userID?.ubication?.currentCountry},{authRequest?.userID?.ubication?.currentDepartment},{authRequest?.userID?.ubication?.currentCity}
                        </div>
                       
                        <div className='text-bold color-purple-dark mt-2'>Motivo de rechazo</div>
                        <input
                            className='height-100 rounded border-box border-light border-secondary-color mt-1'
                            type="text"
                            id="argument"
                            name="argument"
                            value={argument}
                            onChange={(e) => { setargument(e.target.value) }}
                        />

                        <div className="column centerContent">
                            <div className="btns-admin ml-1 mr-1" onClick={() => { dispatch(changeStateAuthRequest(authRequest._id, 2, history)) }}>Aceptar</div>
                            <div className="btn-red btns-admin ml-1" onClick={() => { dispatch(changeStateAuthRequest(authRequest._id, 1, history, argument)) }}>Rechazar</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default CertificateUserAuthRequest
